import "./Traditional.css"

export default function Traditional(props) {
    return(
        // <div className="voiceover-cont-outer">
    <div className="voiceover-container">
      <div className="glow-box">
        <ul>
          <li><span className="hours">10 hrs</span> coding and debugging every little detail</li>
          <li>+ <span className="hours">6 hrs</span> revising content to ensure clarity</li>
          <li>+ <span className="hours">4 hrs</span> testing on different devices and browsers</li>
  
          <li>+ <span className="hours">∞ hrs</span> stressing over the site's performance...</li>
          <br></br>
          <li>= <span className="hours">28+ hours</span> <span className="frustration">of frustration</span></li>
        </ul>
      </div>
      <div className="easier-way">
        <div className="arrow-down">↓</div>
        <p>There's an easier way</p>
      </div>
    </div>
    //  </div>
    )
}